"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalisedDateProperty = void 0;
var get_intl_date_time_format_1 = require("./get-intl-date-time-format");
var get_value_for_date_property_1 = require("./get-value-for-date-property");
/**
 * Gets a localised date property based on the request options.
 * @hidden
 */
var getLocalisedDateProperty = function (request) {
    var _a;
    var date = request.date, languageTag = request.languageTag, ianaTimeZoneName = request.ianaTimeZoneName, property = request.property, format = request.format, hour12 = request.hour12;
    var prop = property === 'dayPeriod' ? 'hour' : property;
    var options = (_a = {
            languageTag: languageTag
        },
        _a[prop] = format,
        _a.timeZone = ianaTimeZoneName,
        _a.hour12 = hour12 !== false || property === 'dayPeriod',
        _a);
    var parts = get_intl_date_time_format_1.getIntlDateTimeFormat(options).formatToParts(date);
    return get_value_for_date_property_1.getValueForDateProperty(parts, property);
};
exports.getLocalisedDateProperty = getLocalisedDateProperty;
//# sourceMappingURL=get-localised-date-property.js.map